import ACTIONS, { FETCH_STATUS } from '../constants';
  
export const assignShiftRequest = (state) => ({
  type: ACTIONS.ASSIGN_SHIFT_CALL,
  payload: state,
});

export const assignShiftAttempt = {
  pending: {
    type: ACTIONS.ASSIGN_SHIFT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.ASSIGN_SHIFT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.ASSIGN_SHIFT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getShiftsRequest = (state) => ({
  type: ACTIONS.SHIFTS_CALL,
  payload: state,
});

export const getShiftsAttempt = {
  pending: {
    type: ACTIONS.SHIFTS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SHIFTS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SHIFTS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createShiftRequest = (state) => ({
  type: ACTIONS.CREATE_SHIFT_CALL,
  payload: state,
});

export const createShiftAttempt = {
  pending: {
    type: ACTIONS.CREATE_SHIFT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_SHIFT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_SHIFT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateShiftRequest = (state) => ({
  type: ACTIONS.UPDATE_SHIFT_CALL,
  payload: state,
});

export const updateShiftAttempt = {
  pending: {
    type: ACTIONS.UPDATE_SHIFT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_SHIFT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_SHIFT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteShiftRequest = (state) => ({
  type: ACTIONS.DELETE_SHIFT_CALL,
  payload: state,
});

export const deleteShiftAttempt = {
  pending: {
    type: ACTIONS.DELETE_SHIFT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_SHIFT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_SHIFT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortShiftRequest = (state) => ({
  type: ACTIONS.SORT_SHIFT_CALL,
  payload: state,
});

export const sortShiftAttempt = {
  pending: {
    type: ACTIONS.SORT_SHIFT.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_SHIFT.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_SHIFT.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateShiftFlag = (state) => ({
  type: ACTIONS.SHIFT_FLAG_CALL,
  payload: state,
});

export const updateShiftFlagAttempt = {
  pending: {
    type: ACTIONS.SHIFT_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SHIFT_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SHIFT_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
